import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, SESSION_EXPIRED_FLAG } from '../context/AuthContext';
import AuthLayout from '../components/AuthLayout';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // Shown once after the app signed the user out because their session expired.
  const [expired] = useState(() => {
    try {
      return Boolean(sessionStorage.getItem(SESSION_EXPIRED_FLAG));
    } catch (e) {
      return false;
    }
  });
  useEffect(() => {
    try {
      sessionStorage.removeItem(SESSION_EXPIRED_FLAG);
    } catch (e) {
      // nothing to clear
    }
  }, []);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    try {
      const result = await login(values.email, values.password);
      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.message || 'Login failed');
      }
    } catch {
      setError('An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Access all areas."
      subtitle={<>Sign in to <strong>Festivals Portal</strong></>}
      footer={
        <>
          New to Festivals Portal? <Link to="/register" className="auth__link">Create an account</Link>
        </>
      }
    >
      {expired && !error && (
        <Alert message="Your session has expired. Sign in again to continue." type="info" showIcon role="status" />
      )}
      {error && <Alert message={error} type="error" showIcon role="alert" />}

      <Form name="login" onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Enter your email' },
            { type: 'email', message: 'Enter a valid email address' },
          ]}
        >
          <Input type="email" placeholder="you@festivals.mt" autoComplete="username" autoFocus />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Enter your password' }]}
        >
          <Input.Password placeholder="Your password" autoComplete="current-password" />
        </Form.Item>

        <div className="auth__aux">
          <Link to="/forgot-password" className="auth__link">Forgot password?</Link>
        </div>

        <Button type="primary" htmlType="submit" loading={loading} className="auth__submit">
          Sign in
        </Button>
      </Form>
    </AuthLayout>
  );
};

export default Login;
